export interface Theme {
    name: string;
    background: string;
    header: string;
    properties: any;
}

export const Football: Theme = {
    name: 'Football',
    background: 'assets/images/bg_soccer.jpg',
    header: 'assets/images/bn_soccer.jpg',
    properties: {
        '--app-background-image': 'url(assets/images/bg_soccer.jpg)',
        '--app-header-image': 'url(assets/images/bn_soccer.jpg)',
        '--app-color-base': '#417e35',
        '--app-color-base-tint': '#58ae47',

        '--app-color-tertiary': '#5aaf49',

        '--app-color-tertiary-shade': '#ffffff1a',
        '--app-color-tertiary-tint': '#58ae47',

        '--app-color-secondary': '#f8fb21',

        '--app-color-odds-up': '#04ff00',
        '--app-color-odds-down': '#ff4546',


        '--app-color-light': '#fff',
        '--app-color-light-tint': '#ccc',
        '--app-color-dark': '#000',
        '--app-color-dark-rgb': 'rgba(0, 0, 0, 0.363)',
        '--app-color-dark-tint': '#212529',
    }
};

export const BasketBall: Theme = {
    name: 'BasketBall',
    background: 'assets/images/bg_soccer.jpg',
    header: 'assets/images/bn_soccer.jpg',
    properties: {
        '--app-background-image': 'url(assets/images/bg_basket.jpg)',
        '--app-header-image': 'url(assets/images/bn_basket.jpg)',
        '--app-color-base': '#cc641a',
        '--app-color-base-tint': '#f87e27',

        '--app-color-tertiary': '#CC651A',

        '--app-color-tertiary-shade': '#ffffff1a',
        '--app-color-tertiary-tint': '#58ae47',

        '--app-color-secondary': '#f8fb21',

        '--app-color-odds-up': '#04ff00',
        '--app-color-odds-down': '#ff4546',


        '--app-color-light': '#fff',
        '--app-color-light-tint': '#ccc',
        '--app-color-dark': '#000',
        '--app-color-dark-rgb': 'rgba(0, 0, 0, 0.363)',
        '--app-color-dark-tint': '#212529',
    }
};

